class MainSearchbarResultSectionObj {
    constructor(name, results) {
        this.name = name;
        this.results = results;
    }
}
module.exports = MainSearchbarResultSectionObj
